import React from 'react';
import { useParams } from 'react-router-dom';
import borderBottom from '../../assets/images/borderBottom.png';
import { SuccessSVG } from '../../components/icons';
import getOrganizationById from '../../helpers/getOrganization';

// Shown after a user chooses "Visit centre" for an offline course. The order has
// been parked as a draft on the server; enrolment is completed in person.
// Mirrors the payment return page (PaymentStatusCard) look.
function VisitCentreConfirmation() {
  const { orgId } = useParams();
  const organizationData = getOrganizationById({ orgId });

  const handleRedirect = () => {
    window.location.href = organizationData?.redirect?.failureURL;
  };

  return (
    <div className="fixed inset-0 z-50 bg-blue-900 overflow-hidden">
      <div className="relative z-10 flex items-center justify-center h-full p-4">
        <div className="bg-white rounded-lg max-w-md w-full text-center p-6 relative shadow-xl">
          <div className="flex justify-center mb-6">
            <div className="w-28 h-28 rounded-full flex items-center justify-center">
              <SuccessSVG />
            </div>
          </div>
          <h2 className="text-2xl font-semibold text-dark mb-4">
            Thank You!
          </h2>
          <p className="text-gray-600 text-lg mb-6">
            Your order has been saved. Since this is an offline course, please
            visit the centre to complete your enrolment and payment. Our team
            will assist you with the next steps.
          </p>
          <button
            type="button"
            onClick={handleRedirect}
            className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 transition-colors"
          >
            Back To Application
          </button>
        </div>
        <img alt="" src={borderBottom} />
      </div>
    </div>
  );
}

export default VisitCentreConfirmation;
